var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"icon input-icon"},[_c('i',{class:_vm.icon})]),_c('input',_vm._g({staticClass:"input has-icon",attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }